import _objectSpread from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { consoleSandbox } from '@sentry/utils';
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production
 */

var Debug =
/*#__PURE__*/
function () {
  _createClass(Debug, null, [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'Debug';
    }
    /**
     * @inheritDoc
     */

  }]);

  function Debug(options) {
    _classCallCheck(this, Debug);

    this.name = Debug.id;
    this._options = _objectSpread({
      debugger: false,
      stringify: false
    }, options);
  }
  /**
   * @inheritDoc
   */


  _createClass(Debug, [{
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      addGlobalEventProcessor(function (event, hint) {
        var self = getCurrentHub().getIntegration(Debug);

        if (self) {
          if (self._options.debugger) {
            // eslint-disable-next-line no-debugger
            debugger;
          }
          /* eslint-disable no-console */


          consoleSandbox(function () {
            if (self._options.stringify) {
              console.log(JSON.stringify(event, null, 2));

              if (Object.keys(hint).length) {
                console.log(JSON.stringify(hint, null, 2));
              }
            } else {
              console.log(event);

              if (Object.keys(hint).length) {
                console.log(hint);
              }
            }
          });
          /* eslint-enable no-console */
        }

        return event;
      });
    }
  }]);

  return Debug;
}();

Debug.__initStatic();

export { Debug };